import React from "react";
import Image from "next/image";
import Link from "next/link";

import { ChevronRight } from "lucide-react";

import { formatImageUrl } from "@/components/blog/Util";

import type { CaseStudiesFields } from "@/pages/partners/[partnerName]";

const CaseStudies = ({ caseStudies }: { caseStudies: CaseStudiesFields }) => {
  return (
    <div className="bg-black text-white px-5 md:px-16 md:pb-28 pb-16">
      <div className="flex flex-col justify-between gap-10 max-w-7xl mx-auto relative">
        <div className="flex flex-col gap-2 font-semibold max-w-3xl">
          <p>Results</p>
          <h1 className="font-clash font-semibold text-4xl md:text-5xl leading-[1.2] tracking-tight">
            Businesses like yours are thriving with Rebolt
          </h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 w-full">
          {caseStudies.map((caseStudy) => (
            <Link
              key={caseStudy.fields.slug}
              href={`/case-studies/${caseStudy.fields.slug}`}
              className="bg-white text-black rounded-3xl overflow-hidden"
            >
              <div className="relative overflow-hidden w-full h-64">
                <Image
                  src={`${formatImageUrl(caseStudy.fields.heroImage?.fields.file.url || "")}`}
                  alt={caseStudy.fields.title}
                  fill
                  className="w-full h-full object-cover"
                  priority
                />
              </div>
              <div className="flex flex-col gap-8 px-6 pt-6 pb-8 ">
                <h3 className="font-clash font-semibold md:text-2xl text-xl tracking-tight">
                  {caseStudy.fields.title}
                </h3>
                <div className="flex flex-col gap-5 justify-between">
                  <div className="flex flex-col">
                    <p className="font-bold text-sm md:text-base">{caseStudy.fields.ownerName}</p>
                    <p className="text-sm md:text-base">Owner of {caseStudy.fields.companyName}</p>
                  </div>

                  <div className="flex items-center gap-2">
                    <p className="font-medium text-sm md:text-base text-rebolt-500 underline">Read full story</p>
                    <ChevronRight className="w-6 h-6 text-rebolt-500 " />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseStudies;
